// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ngw-feature-attachment-image-thumbnail {
  display: flex;
  position: relative;
  margin: 8px;
  height: max-content;
}
.ngw-feature-attachment-image-thumbnail > .overlay {
  display: none;
  position: absolute;
  cursor: pointer;
  inset: 0;
  background-color: rgba(0, 0, 0, 0.25);
  color: white;
}
.ngw-feature-attachment-image-thumbnail:hover > .overlay {
  display: flex;
  justify-content: center;
  align-items: center;
}
`, "",{"version":3,"sources":["webpack://./package/nextgisweb/nextgisweb/feature_attachment/nodepkg/image-thumbnail/ImageThumbnail.less"],"names":[],"mappings":"AAAA;EACI,aAAA;EACA,kBAAA;EACA,WAAA;EACA,mBAAA;AACJ;AALA;EAOQ,aAAA;EACA,kBAAA;EACA,eAAA;EACA,QAAA;EACA,qCAAA;EACA,YAAA;AACR;AAEI;EACI,aAAA;EACA,uBAAA;EACA,mBAAA;AAAR","sourcesContent":[".ngw-feature-attachment-image-thumbnail {\n    display: flex;\n    position: relative;\n    margin: 8px;\n    height: max-content;\n\n    > .overlay {\n        display: none;\n        position: absolute;\n        cursor: pointer;\n        inset: 0;\n        background-color: rgba(0, 0, 0, 0.25);\n        color: white;\n    }\n\n    &:hover > .overlay {\n        display: flex;\n        justify-content: center;\n        align-items: center;\n    }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
